module.exports = __webpack_public_path__ + "img/service_banner.34033ac0.png";